<template>
	<div>
		<el-breadcrumb separator="/" class="breadcrumb">
			<el-breadcrumb-item :to="{ path: '/setting/message-sending' }">{{ $t("router.messageSending") }}</el-breadcrumb-item>
			<el-breadcrumb-item>{{ $t("messageSending.historyRecord") }}</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card class="table-card">
			<el-table
				:data="historyRecords"
				v-loading="loading"
				element-loading-text="loading..."
				stripe
				border
				style="width: 100%"
				:empty-text="loading ? 'loading...' : 'empty'"
			>
				<el-table-column prop="id" :label="$t('messageSending.orderId')"></el-table-column>

				<el-table-column prop="name" :label="$t('messageSending.customerName')"></el-table-column>

				<el-table-column prop="phone_number" :label="$t('messageSending.customerPhone')">
					<template slot-scope="scope">
						<span>{{ scope.row.phone_number }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="content" :label="$t('messageSending.snedText')">
					<template slot-scope="scope">
						<el-popover placement="top" width="650" trigger="hover" @show="handelCheck(scope.row)">
							<div v-if="selectedCustomerRow">
								<el-form label-position="left">
									<el-form-item
										v-for="customer in selectedCustomerRow.customers"
										:key="customer.customer_id"
										:label="$t('messageSending.restaurantId') + '：' + customer.customer_id"
									>
										<el-checkbox-group
											v-model="messageForm.content[customer.customer_id]"
											class="readonly-checkbox-group"
											@click.native.prevent
										>
											<el-checkbox v-for="feature in customer.feature" :key="feature.feature_key" :label="feature.feature_key">
												{{ feature.feature_name }}
											</el-checkbox>
										</el-checkbox-group>
									</el-form-item>
								</el-form>
							</div>

							<el-button slot="reference" type="text">{{ $t("messageSending.check") }}</el-button>
						</el-popover>
					</template>
				</el-table-column>

				<el-table-column prop="sent_time" :label="$t('messageSending.sendTime')">
					<template slot-scope="scope">
						<span>{{ scope.row.sent_time ? formatUtcToLocal(scope.row.sent_time) : "" }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="status" :label="$t('messageSending.sendSuccess')" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.status ? 'success' : 'danger'" size="mini">
							{{ scope.row.status ? $t("messageSending.true") : $t("messageSending.false") }}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="opened_at" :label="$t('messageSending.isCheckedDocument')" width="120">
					<template slot-scope="scope">
						<el-tag :type="scope.row.opened_at ? 'success' : 'danger'" size="mini">
							{{ scope.row.opened_at ? $t("messageSending.true") : $t("messageSending.false") }}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="downloaded_at" :label="$t('messageSending.isDownLoad')">
					<template slot-scope="scope">
						<el-tag :type="scope.row.downloaded_at ? 'success' : 'danger'" size="mini">
							{{ scope.row.downloaded_at ? $t("messageSending.true") : $t("messageSending.false") }}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container" v-if="!loading && totalRecords > 0">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 20, 50]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalRecords"
					background
				></el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
import { getMessageSendHistroy } from "../../services/api-v2/api-v2";
import { formatUtcToLocal } from "@/utils/date";
export default {
	name: "MessageHistory",
	data() {
		return {
			historyRecords: [],
			loading: false,
			currentPage: 1,
			pageSize: 20,
			totalRecords: 0,
			selectedCustomerRow: null,
			messageForm: {
				content: {},
			},
			phone_number: "",
		};
	},
	created() {
		this.phone_number = this.$route.params.id;
		this.loadHistoryRecords();
	},

	methods: {
		formatUtcToLocal,
		async loadHistoryRecords() {
			this.loading = true;
			try {
				const { data } = await getMessageSendHistroy(this.phone_number);
				this.totalRecords = data.length;
				const start = (this.currentPage - 1) * this.pageSize;
				const end = start + this.pageSize;
				this.historyRecords = data.slice(start, end);
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},
		async handelCheck(raw) {
			try {
				const cleanedData = {
					...raw,
					customers: (raw.customers || []).map((customer) => ({
						...customer,
						feature: (customer.feature || []).filter((f) => !f.disabled),
					})),
				};

				this.selectedCustomerRow = cleanedData;
				this.setDefaultSelectedItems();
			} catch (error) {
				this.$message.error(error);
			}
		},
		// 设置默认全选
		setDefaultSelectedItems() {
			const content = {};
			if (this.selectedCustomerRow && this.selectedCustomerRow.customers) {
				this.selectedCustomerRow.customers.forEach((customer) => {
					content[customer.customer_id] = customer.feature.filter((f) => f.status).map((f) => f.feature_key);
				});
			}
			this.messageForm.content = content;
		},
		handleCurrentChange(page) {
			this.currentPage = page;
			this.loadHistoryRecords();
		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.currentPage = 1;
			this.loadHistoryRecords();
		},
	},
};
</script>
<style scoped>
.table-card {
	margin-top: 20px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pagination-container {
	margin-top: 20px;
	text-align: right;
}
/* 禁用交互 */
.readonly-checkbox-group {
	pointer-events: none;
	opacity: 1 !important;
}
</style>
